export function parseJwt(token: string): Record<string, unknown> {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch {
    return {};
  }
}

export function getRoleFromToken(token: string): string | undefined {
  const decoded = parseJwt(token);
  const roles = decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] as string | string[] | undefined;
  if (!roles) {
    return undefined;
  }
  return Array.isArray(roles) ? roles[0] : roles;
}
